import axios from "axios";
import { getNodeServerUrl } from "@utils/getNodeUrl";

const JC_BASE = `${getNodeServerUrl()}/jc-review`;

/**
 * Submit feedback (ZM on BM, or NSM on ZM).
 * @param {Object} payload - { submissionId, reviewerCode, reviewerName, reviewerRole, rating, remarks, sfToken }
 * @returns {Promise}
 */
export const submitFeedbackApi = (payload) =>
  axios.post(`${JC_BASE}/feedback`, payload);

/**
 * Get all feedback entries for a submission.
 * @param {number} submissionId
 * @returns {Promise}
 */
export const getFeedbackApi = (submissionId) =>
  axios.get(`${JC_BASE}/feedback/${submissionId}`);
